import { spacer64, screenSmMax } from '@spotify-internal/encore-web';
import styled from 'styled-components';

const DeleteContainer = styled.div`
  width: 100%;
  max-width: 80%;
  @media (max-width: ${screenSmMax}) {
    max-width: 100%;
  }
`;

const DeleteSection = styled.div`
  margin-top: ${spacer64};
`;

export { DeleteSection, DeleteContainer };
